/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, TouchableHighlight } from 'react-native'
import styles from './Styles/ListItemTextMiddleStyle'
import { Container, Button, Icon, Header, Content, ListItem, CheckBox, Thumbnail, Text, Left, Body, Right } from 'native-base';

export default class ListItemTextMiddle extends Component {

 
  render() {
    const { isBoldText, backgroundColor } = this.props
    return (
      <TouchableHighlight style={[styles.container,{backgroundColor: backgroundColor}]} onPress={this.props.onPress}
       >
        <Text style={isBoldText ? styles.textStyleBold : styles.textStyle}>{this.props.text}</Text>
      
      </TouchableHighlight>

    )
  }
}
